/**
 * @deprecated
 */
export enum ClvRequestType {
  READER, WRITTER
}
